export function setCookie(
	key: string,
	value: string,
	end: number | string | Date,
	path = '/',
	domain = '',
	secure = false
) {
	if (!key || /^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
		return false;
	}
	let expires = '';
	if (end) {
		switch (end.constructor) {
			case Number:
				expires =
					end === Infinity
						? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
						: '; max-age=' + end;
				break;
			case String:
				expires = `; expires=${end}`;
				break;
			case Date:
				expires = `; expires=${(end as Date).toUTCString()}`;
				break;
			default:
				expires = '';
		}
	}
	const keyStr = encodeURIComponent(key);
	const valueStr = encodeURIComponent(value);
	const domainStr = `${domain ? `; domain=${domain}` : ''}`;
	const pathStr = `${path ? `; path=${path}` : ''}`;
	const secureStr = `${secure ? '; secure' : ''}`;
	document.cookie = `${keyStr}=${valueStr}${expires}${domainStr}${pathStr}${secureStr}`;

	return true;
}
